import React from "react";

export default function RefoundPolicy() {
  return <div>RefoundPolicy</div>;
}
